import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { environment } from 'src/environments/environment';
import { AgendaPositivaService } from '../../services/agenda-positiva.service';
import { PesquisaGeralService } from '../../services/pesquisa-geral.service';
import { ProjetoCadastro } from '../../models/projeto-cadastro.model';

@Component({
  selector: 'app-detalhe-entrega-projeto-agenda-positiva-list',
  templateUrl: './detalhe-entrega-projeto-agenda-positiva-list.component.html',
  styleUrls: ['./detalhe-entrega-projeto-agenda-positiva-list.component.scss']
})
export class DetalheEntregaProjetoAgendaPositivaListComponent extends BaseListComponent<any> implements OnInit, OnDestroy {
  idProjeto: number;
  infoProjeto: ProjetoCadastro;
  canCreateAgendaPos: boolean = false;
  novaUrl: string;
  agendaList: any[];
  link: string = environment.serverUrl;
  @Input() idEntrega: number;
  @Input() idOrgao: number;

  constructor(
    private myService: AgendaPositivaService,
    private pesquisaGeralService: PesquisaGeralService,
  ) {
    super();
  }

  ngOnInit() {
    this.pesquisaGeralService.info.subscribe(info => {
      this.infoProjeto = info;
      this.idProjeto = this.infoProjeto.id;
      this.novaUrl = this.link + '/agenda/agenda-positiva/orgao/' + this.idOrgao + '/adicionar?pf_prt_issue_id=' + this.idEntrega;
      this.initList();
    });
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initList() {
    this.addSub(
      this.myService.getListAll(this.idEntrega).subscribe((res) => {
        this.agendaList = res['agenda'];
        this.canCreateAgendaPos = res['canCreateAgendaPos'];
        this.loaded();
      })
    );
  }

  editar(id: number){
    window.open(`${environment.serverUrl}/agenda/agenda-positiva/${id}`, '_blank');
  }
}
